import React from 'react';
import { Email, User, UserInfo } from 'views/components/organisms/UserInfo';
import styled from '@emotion/styled';
import { Color, FontSize, ROUTER_PATH, MAX_WIDTH } from 'views/constants';
import { Typography } from 'views/components/atoms/Typography';
import { Spacer } from 'views/components/atoms/Spacer';
import { Button } from 'views/components/atoms/Button';
import { AppLinkList } from 'views/components/organisms/AppLinkList';
import emptyImage from 'views/layouts/AppsPageLayout/images/empty.png';
import { Image } from 'views/components/atoms/Image';
import { Driver } from 'views/components/atoms/Driver';
import { FormattedMessage } from 'react-intl';
import { localeIds } from 'locals';
import { AvailableApps } from 'models/Device/type';
import { TableLink } from 'views/components/atoms/TableLink';

const TableLinkWrapper = styled.div`
  background-color: ${Color.C6};
`;

const ContentsWrapper = styled.div`
  text-align: initial;
  padding-bottom: 28px;
`;

const AppsLabelWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

const EmptyContentWrapper = styled.div`
  text-align: center;
`;

const EmptyImageWrapper = styled.div`
  margin: auto;
  width: 150px;
`;

const ButtonWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

type AppsPageLayoutProps = {
  userInfo: User | Email;
  availableApps: AvailableApps;
  isLogin?: boolean;
  onLogout(): void;
  onLogin(): void;
  onReInstall(): void;
};

export const AppsPageLayout: React.FC<AppsPageLayoutProps> = ({
  userInfo,
  availableApps,
  isLogin,
  onLogout,
  onLogin,
  onReInstall,
}) => (
  <>
    <UserInfo info={userInfo} />
    {isLogin ? null : (
      <TableLinkWrapper>
        <TableLink to={ROUTER_PATH.notificationSetting}>
          <Typography bold>
            <FormattedMessage
              id={localeIds.appsPageLayout.notificationSetting}
            />
          </Typography>
        </TableLink>
        <Driver />
      </TableLinkWrapper>
    )}

    <ContentsWrapper>
      <Spacer size="large" />

      <AppsLabelWrapper>
        <Typography bold color={Color.C3} size={FontSize.S}>
          <FormattedMessage id={localeIds.appsPageLayout.availableApps} />
        </Typography>
      </AppsLabelWrapper>

      <Spacer />

      <Driver />

      {availableApps.applications.length === 0 &&
      availableApps.distributions.length === 0 ? (
        <EmptyContentWrapper>
          <Spacer size="large" />
          <EmptyImageWrapper>
            <Image src={emptyImage} />
          </EmptyImageWrapper>
          <Spacer />
          <Typography bold color={Color.C3}>
            <FormattedMessage id={localeIds.appsPageLayout.noAvailableApps} />
          </Typography>
          <Spacer />
          <Typography color={Color.C3} size={FontSize.S}>
            <FormattedMessage id={localeIds.appsPageLayout.waitForEnginner} />
          </Typography>
          <Spacer size="large" />
        </EmptyContentWrapper>
      ) : (
        <AppLinkList
          applications={availableApps.applications}
          distributions={availableApps.distributions}
        />
      )}

      <Driver />

      <Spacer />

      <ButtonWrapper>
        {isLogin ? (
          <Button type="submit" style="secondary" onClick={onLogout}>
            <FormattedMessage id={localeIds.appsPageLayout.logout} />
          </Button>
        ) : (
          <Button type="submit" style="secondary" onClick={onLogin}>
            <FormattedMessage id={localeIds.appsPageLayout.login} />
          </Button>
        )}

        <Spacer />

        <Button type="submit" style="primary" onClick={onReInstall}>
          <FormattedMessage id={localeIds.appsPageLayout.reInstall} />
        </Button>
      </ButtonWrapper>
    </ContentsWrapper>
  </>
);
